import { useState } from 'react'
import { Button } from 'components'

import { useFormContext } from 'react-hook-form'
import { useOrderStore } from 'modules/orders/store'
import { useLoadOrderCalculateTotal } from 'modules/orders/hooks'
import { unwrapCalculateTotalResponse, useDebounce } from 'utils'
import { toast } from 'react-toastify'
import { recalculateOrderTotals } from './recalculateOrderTotals'

export const RecalculeButton = () => {
  const [loading, setLoading] = useState(false)
  const { watch } = useFormContext()

  const form = useOrderStore.useForm()
  const setForm = useOrderStore.useSetForm()
  const setIsTaxesRecalculePending =
    useOrderStore.useSetIsTaxesRecalculePending()
  const isTaxesRecalculePending = useOrderStore.useIsTaxesRecalculePending()

  const discountDeb = useDebounce(watch('totalDiscount'), 500)
  const expensesDeb = useDebounce(watch('totalExpenses'), 500)
  const freightPriceDeb = useDebounce(watch('freightPrice'), 500)
  const [customer, orderType, unity, paymentTerm] = watch([
    'customer',
    'orderType',
    'unity',
    'paymentTerm'
  ])

  const { refetch: refetchTotal } = useLoadOrderCalculateTotal({
    isTaxesRecalculePending,
    totalDiscount: Number(discountDeb || 0),
    totalExpenses: Number(expensesDeb || 0),
    freightPrice: Number(freightPriceDeb || 0),
    items: form?.orderItems
  })

  const handleOnClick = async () => {
    setLoading(true)

    try {
      if (orderType?.id === 'P') {
        const { data } = await refetchTotal()

        const total = unwrapCalculateTotalResponse(data)
        if (total) {
          setForm({ total })
          setIsTaxesRecalculePending(false)
        }
        return
      }

      const total = await recalculateOrderTotals({
        orderTypeId: orderType?.id,
        customerId: customer?.id,
        unityId: unity?.id,
        paymentTermId: paymentTerm?.id,
        items: form.orderItems,
        totalDiscount: +discountDeb,
        totalExpenses: +expensesDeb,
        freightPrice: +freightPriceDeb
      })

      if (total) {
        setForm({ total })
        setIsTaxesRecalculePending(false)
      }
    } catch {
      toast.error('Não foi calcular os impostos!', {
        toastId: 'recalcule-taxes'
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button onClick={handleOnClick} disabled={loading} loading={loading}>
      Calcular impostos
    </Button>
  )
}
